import React, { useEffect, useState } from "react";
import {
  createFaq,
  updateFaq
} from "./adminFaqService";

const FaqForm = ({ faq, onSaved, onCancel }) => {

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    youtubeVideoLink: "",
    displayOrder: ""
  });

  const [saving, setSaving] = useState(false);

  useEffect(() => {

    if (faq) {
      setFormData({
        question: faq.question || "",
        answer: faq.answer || "",
        youtubeVideoLink: faq.youtubeVideoLink || ""
      });
    }

  }, [faq]);

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!formData.question.trim()) {
      alert("Question is required");
      return;
    }

    if (!formData.answer.trim()) {
      alert("Answer is required");
      return;
    }

    setSaving(true);

    let response;

    if (faq && faq.id) {

      response = await updateFaq(faq.id, formData);

    } else {

      response = await createFaq(formData);

    }

    setSaving(false);

    if (response.status === 200 || response.status === 201) {

      alert(response.message);
      onSaved();

    } else {

      alert(response.message || "Save failed");

    }

  };

  return (

    <div className="form-card">

      <div className="form-header">
        <h2>{faq ? "Edit FAQ" : "Create FAQ"}</h2>
      </div>

      <form onSubmit={handleSubmit}>

        <div className="form-grid">

          <div className="form-group full-width">
            <label>Question</label>
            <textarea
              name="question"
              value={formData.question}
              onChange={handleChange}
              rows="3"
              placeholder="Enter FAQ question"
            />
          </div>

          <div className="form-group full-width">
            <label>Answer</label>
            <textarea
              name="answer"
              value={formData.answer}
              onChange={handleChange}
              rows="6"
              placeholder="Enter FAQ answer"
            />
          </div>

          <div className="form-group full-width">
            <label>YouTube Video Link</label>
            <input
              type="text"
              name="youtubeVideoLink"
              value={formData.youtubeVideoLink}
              onChange={handleChange}
              placeholder="Enter YouTube video link"
            />
          </div>

          <div className="form-group">
  <label>Display Order</label>
  <input
    type="number"
    name="displayOrder"
    value={formData.displayOrder}
    onChange={handleChange}
    placeholder="Enter display order"
  />
</div>

        </div>

        <div className="form-actions">

          <button
            type="submit"
            className="btn primary"
            disabled={saving}
          >
            {saving ? "Saving..." : faq ? "Update FAQ" : "Create FAQ"}
          </button>

          <button
            type="button"
            className="btn secondary"
            onClick={onCancel}
            disabled={saving}
          >
            Cancel
          </button>

        </div>

      </form>

    </div>

  );

};

export default FaqForm;